import axios from '@/axios.js'

// Le JWT part en en-tête (intercepteur axios) : les téléchargements passent par
// un blob + lien, jamais par window.open sur l'URL de l'API.
function saveBlob (data, type, filename) {
  const url = window.URL.createObjectURL(new Blob([data], { type }))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export default {
  // GET /api/reports/centralizator?from&to → { from, to, rows, totals }
  fetchCentralizator (_, { from, to }) {
    return axios.get('/reports/centralizator', { params: { from, to } })
  },
  // GET /api/reports/centralizator/xlsx?from&to → classeur « Export Carmen »
  downloadCentralizatorXlsx (_, { from, to }) {
    return axios
      .get('/reports/centralizator/xlsx', { params: { from, to }, responseType: 'blob' })
      .then(response => {
        saveBlob(
          response.data,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          `Centralizator_${from}_${to}.xlsx`
        )
        return response
      })
  }
}
